import { render, staticRenderFns } from "./CreateShippingAccountModal.vue?vue&type=template&id=6c740ed5&"
import script from "./CreateShippingAccountModal.vue?vue&type=script&lang=js&"
export * from "./CreateShippingAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports